import React from 'react'
import styled from 'styled-components'
import { CSSTransition } from "react-transition-group";
import Thankyou from '../icons/Thankyou';
import ThanksText from '../icons/ThanksText';
import Lottie from 'react-lottie';
import animationData from '../icons/Check.json';

const Thanks = styled.div`
  background-image: url("/background.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &.overlay-enter {
    opacity: 0;
  }

  &.overlay-enter-active {
    opacity: 1;
    transform: translateX(0);
    transition: opacity 0.3s, transform 0.3s;
  }

  &.overlay-exit {
    opacity: 1;
  }

  &.overlay-exit-active {
    opacity: 0;
    transition: opacity 0.3s, transform 0.3s;
  }
`

const TanksContainer = styled.div`
  margin: 0 15%;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: space-between;
  max-width: 1504px;
  & p {
    color: #ccc;
  }
`

const TanksTextGroup = styled.div`
  width: 65%;
  svg {
    width: 100%;
    max-width: 962px;
  }
`

const TanksTitle = styled.h1`
  margin-bottom: min(5vw, 90px);
`
const ThanksCheckContainer = styled.div`
  width: 20%;
  margin-left: 15%;
  min-width: 48px;

  & svg {
    width: 100%;
    min-width: 48px;
    max-width: 299px;
  }
`


const ThanksWrapper: React.FC<{isOpen: boolean}> = (props) => {
  const nodeRef = React.useRef(null)

  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData
  };

  return (
    <CSSTransition
      nodeRef={nodeRef}
      classNames="overlay"
      in={props.isOpen}
      timeout={2000}
      unmountOnExit
    >
      <Thanks ref={nodeRef}>
        <TanksContainer>
          <TanksTextGroup>
            <TanksTitle>
              <Thankyou />
            </TanksTitle>
            <p>
              <ThanksText />
            </p>
          </TanksTextGroup>

          <ThanksCheckContainer>
            <Lottie options={defaultOptions} />
          </ThanksCheckContainer>
        </TanksContainer>
      </Thanks>
    </CSSTransition>
  )
}

export default ThanksWrapper
